// @flow
import { type Store } from 'effector'
import { camelize } from 'utils/camelize'
import * as CURRENCY from 'services/currency/data'
import type { WindowAppOptions } from '../types'
import { domain } from './domain'

export const DEFAULT_APP_OPTIONS: WindowAppOptions = {
  currency: {
    code: CURRENCY.DEFAULT_CURRENCY,
    exchangeRate: CURRENCY.DEFAULT_EXCHANGE_RATE,
  },
  showOlympiadBanner: false,
  prerender: false,
  phoneConfirmationType: 'sms',
}

domain.onCreateStore((store) => {
  if (store.shortName === 'appOptions') {
    store.setState(camelize(window?.app_options || DEFAULT_APP_OPTIONS))
  }
})

const $appOptions: Store<WindowAppOptions> = domain.createStore(DEFAULT_APP_OPTIONS, { name: 'appOptions' })

export { $appOptions }
